import {ContentKeyPair} from "./Keys";
import {CellContent} from "./CellContent";
import {CellSize} from "./CellSize";
import {ContentCell} from "./ContentCell";

export class ClipboardCell {

    private readonly key_pair: ContentKeyPair;
    private readonly size: CellSize;
    private readonly content: CellContent;

    constructor(key_pair: ContentKeyPair, size: CellSize, content: CellContent) {
        this.key_pair = key_pair;
        this.size = size;
        this.content = content;
    }

    get KeyPair() {
        return this.key_pair;
    }

    get Content() {
        return this.content;
    }

    get Size() {
        return this.size;
    }

    isPasteableTo(cell: ContentCell) {

        if (this.key_pair.equals(cell.KeyPair)
            && this.content.equals(cell.data)
        ) {
            // 現状、Lexical の key が異なるので、常に 別コンテンツとして認識されてる (ので、この条件あまり意味ない)
            return false;
        }

        if (!this.content.compatibleEditorType(cell.data)) {
            return false;
        }

        return true;
    }

    toJSON() {
        return {
            key_pair: this.key_pair,
            size: this.size,
            content: this.content.toJSON(),
        }
    }

    toString() {
        return JSON.stringify(this.toJSON());
    }

    static fromString(string: string) {
        const json = JSON.parse(string);
        return new ClipboardCell(
            ContentKeyPair.fromJSON(json.key_pair),
            CellSize.fromJSON(json.size),
            CellContent.fromJSON(json.content)
        );
    }

}
